import * as React from 'react';
/**
 * Once a component receives a controlled value, keep it controlled even when
 * the host intentionally clears that value back to `undefined`.
 */ export function useControlledLatch(controlled) {
    const everControlled = React.useRef(controlled);
    React.useEffect(()=>{
        if (controlled) everControlled.current = true;
    }, [
        controlled
    ]);
    return controlled || everControlled.current;
}
